import * as React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "components/bootstrap";
import useEventActionCondition, {
  isNotSystemEvent
} from "security-app/components/Investigations/plugin/useEventActionCondition";
import useDeselectEntities from "common/hooks/useDeselectEntities";
import AddEvidenceModal from "./shared/AddEvidenceModal";
const EventInvestigationsModalInner = ({ events, fromBulk = false }, ref) => {
  const isAvailable = useEventActionCondition(events);
  const deselectEntities = useDeselectEntities();
  if (!isAvailable) {
    return null;
  }
  const eventIds = events.filter(isNotSystemEvent).map(({ id }) => id);
  return /* @__PURE__ */ React.createElement(
    AddEvidenceModal,
    {
      ids: eventIds,
      type: "events",
      ref,
      fromBulk,
      onCompleted: () => deselectEntities(eventIds)
    }
  );
};
export const EventInvestigationsModal = React.forwardRef(EventInvestigationsModalInner);
const InvestigationsEventAction = ({ events, modalRef, onEventCallback }) => {
  const { t } = useTranslation("enterprise_security_investigations");
  const eventIds = events.filter(isNotSystemEvent).map(({ id }) => id);
  if (eventIds.length === 0) {
    return null;
  }
  const onSelectInvestigation = () => {
    var _a;
    if (typeof onEventCallback === "function") {
      onEventCallback();
    }
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  };
  return /* @__PURE__ */ React.createElement(MenuItem, { onClick: onSelectInvestigation, icon: "extension" }, t("core_actions.add_to_investigation"));
};
export default InvestigationsEventAction;
